import { hex_sha1 } from './sha1'

function getExplore () {
  var Sys = {};
  var ua = navigator.userAgent.toLowerCase();
  var s;
  (s = ua.match(/rv:([\d.]+)\) like gecko/)) ? Sys.ie = s[1] :
    (s = ua.match(/msie ([\d\.]+)/)) ? Sys.ie = s[1] :
      (s = ua.match(/edge\/([\d\.]+)/)) ? Sys.edge = s[1] :
        (s = ua.match(/firefox\/([\d\.]+)/)) ? Sys.firefox = s[1] :
          (s = ua.match(/(?:opera|opr).([\d\.]+)/)) ? Sys.opera = s[1] :
            (s = ua.match(/chrome\/([\d\.]+)/)) ? Sys.chrome = s[1] :
              (s = ua.match(/version\/([\d\.]+).*safari/)) ? Sys.safari = s[1] : 0;
  // 根据关系进行判断
  if (Sys.ie) return ('IE: ' + Sys.ie);
  if (Sys.edge) return ('EDGE: ' + Sys.edge);
  if (Sys.firefox) return ('Firefox: ' + Sys.firefox);
  if (Sys.chrome) return ('Chrome: ' + Sys.chrome);
  if (Sys.opera) return ('Opera: ' + Sys.opera);
  if (Sys.safari) return ('Safari: ' + Sys.safari);
  return 'Unkonwn';
}
function getOsInfo () {
  var userAgent = navigator.userAgent.toLowerCase();
  var name = 'Unknown';
  // var version = 'Unknown';
  if (userAgent.indexOf('win') > -1) {
    // name = 'Windows';
    if (userAgent.indexOf('windows nt 5.0') > -1) {
      name = 'Windows 2000';
    } else if (userAgent.indexOf('windows nt 5.1') > -1 || userAgent.indexOf('windows nt 5.2') > -1) {
      name = 'Windows XP';
    } else if (userAgent.indexOf('windows nt 6.0') > -1) {
      name = 'Windows Vista';
    } else if (userAgent.indexOf('windows nt 6.1') > -1 || userAgent.indexOf('windows 7') > -1) {
      name = 'Windows 7';
    } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows 8') > -1) {
      name = 'Windows 8';
    } else if (userAgent.indexOf('windows nt 6.3') > -1) {
      name = 'Windows 8.1';
    } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows nt 10.0') > -1) {
      name = 'Windows 10';
    } else {
      name = 'Unknown';
    }
  } else if (userAgent.indexOf('iphone') > -1) {
    name = 'Iphone';
  } else if (userAgent.indexOf('mac') > -1) {
    name = 'Mac';
  } else if (userAgent.indexOf('x11') > -1 || userAgent.indexOf('unix') > -1 || userAgent.indexOf('sunname') > -1 || userAgent.indexOf('bsd') > -1) {
    name = 'Unix';
  } else if (userAgent.indexOf('linux') > -1) {
    if (userAgent.indexOf('android') > -1) {
      name = 'Android';
    } else {
      name = 'Linux';
    }
  } else {
    name = 'Unknown';
  }
  return name
  // return { name, version };
}
function uuid () {
  var calculate = function (src) {
    return hex_sha1(src);
  }
  var counter = 0;
  var create = function () {
    var dt = new Date();
    var id1 = dt.getTime();
    var id2 = Math.random() * Number.MAX_VALUE;
    //var id3 = Capabilities.serverString;
    var id3 = navigator.userAgent;
    // var rawID = calculate(id1 + id3 + id2 + counter++).toUpperCase();
    var rawID = calculate(id1 + id3 + id2 + counter++).toLowerCase();
    var finalString = rawID.substring(0, 8) + "-" + rawID.substring(8, 12) + "-" + rawID.substring(12, 16) + "-" + rawID.substring(16, 20) + "-" + rawID.substring(20, 32);
    return finalString;
  }
  var _uuid = '';
  if (sessionStorage.getItem('bf_uuid')) {
    _uuid = sessionStorage.getItem('bf_uuid');
  } else {
    _uuid = create();
    sessionStorage.setItem('bf_uuid', _uuid);
  }
  return _uuid;
}
function fudid () {
  var _fudid = '';
  if (localStorage.getItem('bf_fudid')) {
    _fudid = localStorage.getItem('bf_fudid');
    return _fudid
  }
  var calculate = function (src) {
    return hex_sha1(src);
  }
  var counter = 0;
  var create = function () {
    var dt = new Date();
    var id1 = dt.getTime();
    var id2 = Math.random() * Number.MAX_VALUE;
    //var id3 = Capabilities.serverString;
    var id3 = navigator.userAgent;
    var rawID = calculate(id1 + id3 + id2 + counter++).toUpperCase();
    var finalString = rawID.substring(0, 8) + rawID.substring(8, 12) + rawID.substring(12, 16) + rawID.substring(16, 20) + rawID.substring(20, 32);
    // return finalString.toLocaleLowerCase();
    return finalString.toLocaleUpperCase();
  }
  _fudid = create();
  localStorage.setItem('bf_fudid', _fudid)
  return _fudid;
}
function getYMD () {
  var date = new Date();
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  var d = date.getDate();
  if (m < 10) {
    m = '0' + m
  }
  if (d < 10) {
    d = '0' + d
  }
  return `${y}${m}${d}`
}

export {
  getExplore,
  getOsInfo,
  uuid,
  fudid,
  getYMD
}



// WEBPACK FOOTER //
// ./src/utils/index.js